import Vue from 'vue'
import Router from 'vue-router';
import Routes from '@/router/routes'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    /*beforeEach(to, from, next) {
        console.log(to)
        console.log(from)
        next()
    },*/
    routes: Routes
})

/*
Demora mais, pois sempre será verificado no localstore em toda a requisição, deixando mais lento o processamento.
router.beforeEach((to, from, next) => {

    //console.log('origem:' + from.name)

    let isAuthenticated = false

    if (localStorage.getItem('account')) {
        //console.log('possui')
        let account = JSON.parse(localStorage.getItem('account'))

        if (account.token !== '') {
            isAuthenticated = true
        }

    } else {
        //console.log('nao possui')
    }

    if ((to.name !== 'login' && to.name !== 'recovery') && !isAuthenticated) next({name: 'login'})
    else next()

})*/

export default router
